import { ActionModal } from "@/shared/base/components/ActionModal/ActionModal";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";
import { UseToggle } from "@/shared/base/hooks/useToggle";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";

export function CartBackButtonWarningModal({
  modalProps,
  onClickBack,
}: {
  modalProps: UseToggle;
  onClickBack: () => void;
}) {
  const { languages } = useTeamConfig();
  const cancelCartEventLabel = languages?.purchaseSeats?.cancelCartEventLabel || "games"; // prettier-ignore

  return (
    <ActionModal
      isOpen={modalProps.open}
      onClose={modalProps.toggle}
      renderHeader={() => {
        return (
          <Box py={2} px={3}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={600}
            >
              Timeout
            </Typography>
          </Box>
        );
      }}
      renderBody={() => {
        return (
          <Box>
            <Divider />
            <Box p={3}>
              <Typography variant="body1" color="text.secondary">
                Going back will cancel your cart and take you to the select{" "}
                {cancelCartEventLabel} section.
              </Typography>
            </Box>
            <Divider />
          </Box>
        );
      }}
      renderFooter={() => {
        return (
          <Stack
            p={2}
            direction={"row"}
            justifyContent={"flex-end"}
            spacing={2}
          >
            <Box width={"120px"}>
              <ModalActionButton
                variant="secondary"
                onClick={() => modalProps.toggle()}
              >
                Close
              </ModalActionButton>
            </Box>
            <Box width={"120px"}>
              <ModalActionButton variant="primary" onClick={onClickBack}>
                Go Back
              </ModalActionButton>
            </Box>
          </Stack>
        );
      }}
    />
  );
}
